(() => {
    const dropdownListComponents = document.querySelectorAll('.dropdown-list-component');

    let closeAllDropdownsRegisteredEvent = false;

    let closeAllDropdowns = () => {
        dropdownListComponents.forEach((component) => {
            component
                .querySelector('.dropdown-list-component--toggle-btn')
                .setAttribute('aria-expanded', 'false');
        });
    };

    let closeAllDropdownsEvent = (event) => {
        if (
            !event.target.matches('.dropdown-list-component--toggle-btn') &&
            !event.target.closest('.dropdown-list-component--list')
        ) {
            closeAllDropdowns();

            if (closeAllDropdownsRegisteredEvent) {
                document.removeEventListener('click', closeAllDropdownsEvent);
                closeAllDropdownsRegisteredEvent = undefined;
            }
        }
    };

    dropdownListComponents.forEach((component) => {
        component
            .querySelector('.dropdown-list-component--toggle-btn')
            .addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();

                if (event.currentTarget.getAttribute('aria-expanded') === 'true') {
                    event.currentTarget.setAttribute('aria-expanded', 'false');

                    if (closeAllDropdownsRegisteredEvent) {
                        document.removeEventListener('click', closeAllDropdownsEvent);
                        closeAllDropdownsRegisteredEvent = false;
                    }
                } else {
                    // Close all dropdowns before opening the current one
                    closeAllDropdowns();

                    event.currentTarget.setAttribute('aria-expanded', 'true');

                    if (!closeAllDropdownsRegisteredEvent) {
                        document.addEventListener('click', closeAllDropdownsEvent);
                        closeAllDropdownsRegisteredEvent = true;
                    }
                }
            });
    });
})();
